import { getFieldLabel } from "../forecastContext";
import {
  type ContextViewPayload,
  selectedContextFields
} from "./contextViewPayload";

/** Fields spelled out before the rest collapse into a count. */
const MAX_FIELDS = 3;
/** Values spelled out per field before the rest collapse into a count. */
const MAX_VALUES = 2;

function describeValues(values: string[]): string {
  const shown = values.slice(0, MAX_VALUES).join(", ");
  const rest = values.length - MAX_VALUES;
  return rest > 0 ? `${shown} +${rest}` : shown;
}

/**
 * One line naming what a context view selects, for the picker row. Derived
 * from the payload, so a row can't promise a brand the view no longer names.
 *
 * Capped: a context can pin all twelve dimensions, and spelling every value
 * out made the row — and the popover — as wide as the page. The first few
 * fields say what kind of context it is; the count says how tight.
 */
export function describeContextView(payload: ContextViewPayload): string {
  const fields = selectedContextFields(payload.context);
  const parts = fields
    .slice(0, MAX_FIELDS)
    .map(
      ([field, values]) => `${getFieldLabel(field)}: ${describeValues(values)}`
    );
  const rest = fields.length - MAX_FIELDS;
  if (rest > 0) parts.push(`+${rest} more`);
  if (payload.storeStatuses.length) {
    parts.push(`Store status: ${describeValues(payload.storeStatuses)}`);
  }
  return parts.length ? parts.join(" · ") : "Everything";
}
